const Poppins_400Regular = {fontFamily: 'Poppins-Regular'};
const Poppins_600SemiBold = {fontFamily: 'Poppins-SemiBold'};

export const fonts = {
  Poppins_400Regular: {...Poppins_400Regular},
  Poppins_600SemiBold: {...Poppins_600SemiBold},
};
